import { render } from "./CategorizedUploadDropzone.vue?vue&type=template&id=ba9df8ce&scoped=true"
import script from "./CategorizedUploadDropzone.vue?vue&type=script&lang=js"
export * from "./CategorizedUploadDropzone.vue?vue&type=script&lang=js"

import "../forms/form.css?vue&type=style&index=0&id=ba9df8ce&scoped=true&lang=css&external"
import "./CategorizedUploadDropzone.vue?vue&type=style&index=1&id=ba9df8ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba9df8ce"]])

export default __exports__